// Total visits service - tracks unique site visitors
import { db } from '../firebase';
import { doc, getDoc, setDoc, increment } from 'firebase/firestore';

const TOTAL_VISITS_DOC_ID = 'total_visits';
const VISITS_COLLECTION = 'site_stats';

// Check if user has already been counted in this session
export const hasUserVisited = () => {
  return sessionStorage.getItem('rentvibe_visit_counted') === 'true';
};

// Mark user as counted for this session
export const markUserVisited = () => {
  sessionStorage.setItem('rentvibe_visit_counted', 'true');
};

// Get current total visits from Firestore
export const getTotalVisits = async () => {
  try {
    const docRef = doc(db, VISITS_COLLECTION, TOTAL_VISITS_DOC_ID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data().count || 0;
    } else {
      // Initialize with 0 if document doesn't exist
      await setDoc(docRef, { count: 0, lastUpdated: new Date() });
      return 0;
    }
  } catch (error) {
    console.error('Error getting total visits:', error);
    return 0;
  }
};

// Increment total visits (only for new unique visitors)
export const incrementTotalVisits = async () => {
  try {
    if (hasUserVisited()) {
      // User already counted in this session, just return current count
      return await getTotalVisits();
    }

    // Mark user as visited first
    markUserVisited();

    // Increment count in Firestore
    const docRef = doc(db, VISITS_COLLECTION, TOTAL_VISITS_DOC_ID);
    await setDoc(docRef, {
      count: increment(1),
      lastUpdated: new Date(),
    }, { merge: true });

    // Return the new count
    return await getTotalVisits();
  } catch (error) {
    console.error('Error incrementing total visits:', error);
    return 0;
  }
};
